module.exports = __webpack_public_path__ + "img/logo_doconomy.4094233e.svg";